// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar-subTitle[data-v-13cb2dc9] {\n  font-weight: 500;\n  font-size: 16px;\n  color: #151B1E;\n  text-align: center;\n}\n.sidebar-subTitle + a img[data-v-13cb2dc9] {\n  width: 100%;\n  max-width: 300px;\n  margin: 0 auto;\n  display: block;\n}", ""]);
// Exports
module.exports = exports;
